<app-spinner></app-spinner>

<router-outlet></router-outlet>